
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/static",
      function () {
        return require("private-next-pages/static.js");
      }
    ]);
  